module.exports = __webpack_public_path__ + "static/media/features-immersive-gray.2ca9b13f.png";